import React, { useState } from 'react';
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { useGetDisciplines } from 'helpers/commonCodes';
import SelectorDisciplineCombo from './selectorDisciplineCombo';
import SelectorDisciplineMenu from './selectorDisciplineMenu';
import { sortDataByFieldDesc } from 'helpers/utils';


export default function SelectorDiscipline({ display_type = "menu", page = "schedule" }) {
    let params = useUrlFriendlyToParameters();
    let arrHasRecords = ['ARC', 'ATH', 'CLB', 'CSP', 'CTR', 'MPN', 'ROW', 'SHO', 'SWM', 'WLF'];
    let arrHasTeams = ['ARC', 'ATH', 'BDM', 'BX3', 'BSC', 'CSL', 'CSP', 'DIV', 'FEN', 'HBB', 'JUD', 'MPN', 'PDL', 'RU7', 'SHO', 'SWA', 'TEQ', 'TRI', 'TTE'];

    //get disciplines from memory 
    const data = useGetDisciplines(params);
    let dataFilter

    if (page === "records") {
        dataFilter = data?.disciplines ? data?.disciplines?.filter(item => arrHasRecords.includes(item.code)) : []
    } else if (page === 'teams') {
        dataFilter = data?.disciplines ? data?.disciplines?.filter(item => arrHasTeams.includes(item.code)) : []
    } else {
        dataFilter = data?.disciplines
    }

    //Array.isArray(dataFilter) && dataFilter.sort((a, b) => (a.description.toUpperCase() > b.description.toUpperCase()) ? 1 : -1)
    sortDataByFieldDesc(dataFilter, 'description')

    return (<>
        {display_type === "menu" ?
            (
                <SelectorDisciplineMenu data={dataFilter} page={page} />
            ) : (
                <SelectorDisciplineCombo data={dataFilter} page={page} />
            )
        }
    </>

    );
};




